import * as React from "react";
import { Paginator } from "primereact/paginator";

import { PagedList } from "../../types/dataQueries/base/PagedList";
import { DataQueryBase } from "../../types/dataQueries/base/DataQueryBase";
import { IIdKeyEntityBase } from "../../types/models/base/IIdKeyEntityBase";


export interface DataItemProps<T extends IIdKeyEntityBase<number>> {
  item: T;
}

interface DataPagerProps<T extends IIdKeyEntityBase<number>, TQ extends DataQueryBase<T>> {
  data: PagedList<T>;
  query: TQ;
  updateQuery: (query: TQ) => void;
  itemTemplate: (props: DataItemProps<T>) => React.ReactNode;
  loading?: boolean;
}

export const DataPager: <T extends IIdKeyEntityBase<number>, TQ extends DataQueryBase<T>>(props: DataPagerProps<T, TQ>) =>
  React.ReactElement = <T extends IIdKeyEntityBase<number>, TQ extends DataQueryBase<T>>(props: DataPagerProps<T, TQ>) => {
    const onPageChange = (event: any) => {
    props.updateQuery({ ...props.query, Take: event.rows, Skip: event.first });
  };

  const hasItems = props.data.Items.length > 0;

  return (
    <div className={`data-pager${props.loading ? ` data-pager--loading` : ``}`}>
      {props.loading && (
        <div className="block-loading-overlay" aria-busy="true" aria-live="polite">
          <i className="fa-solid fa-spinner fa-spin" aria-hidden="true" />
          <span>Загрузка…</span>
        </div>
      )}
      {hasItems && props.data.Items.map(e => (
        <React.Fragment key={e.Id}>{props.itemTemplate({ item: e })}</React.Fragment>
      ))}
      {hasItems && (
        <Paginator
          totalRecords={props.data.TotalCount}
          rows={props.query.Take ?? 0}
          first={props.query.Skip ?? 0}
          onPageChange={onPageChange} />
      )}
      {!props.loading && !hasItems && (
        <div className="p-paginator p-component">Нет данных для отображения</div>
      )}
      {props.loading && !hasItems && (
        <div className="data-pager-loading-placeholder" aria-hidden="true" />
      )}
    </div>
  );
}
